import { Component, OnInit } from '@angular/core';
import { Bind } from 'primeng/bind';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
    selector: 'pos-spinner-icon',
    templateUrl: './spinner-icon.component.html',
    styleUrls: ['./spinner-icon.component.scss'],
    imports: [Bind, ProgressSpinner]
})
export class SpinnerIconComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
